import { render, staticRenderFns } from "./SettingsStagePointsForTie.vue?vue&type=template&id=4dda8c50&"
import script from "./SettingsStagePointsForTie.vue?vue&type=script&lang=js&"
export * from "./SettingsStagePointsForTie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports